const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://mojterapeuta.app/';

export default {
    API_BASE_URL: API_BASE_URL,
    APP_NAME: 'MójTerapeuta.app',
    PATH_PREFIX: '/api',
}
